import { LoaderFunctionArgs } from "react-router-dom";
import { ForgotPasswordConfirm } from "../../actions/forgot-password";

export const ForgotPasswordConfirmLoader = async (args: LoaderFunctionArgs) => {
  return await ForgotPasswordConfirm();
};
